import { createNamespacedHelpers } from 'vuex';

import Request from '@/core/QuRequest';

const req = new Request();

const { mapState, mapActions } = createNamespacedHelpers(
  'directSaleReport/dataView',
);

export default {
  data() {
    return {
      // 0 按天
      // 1 汇总
      sum: 0,
    };
  },

  computed: {
    ...mapState({
      sale: (state) => state.sale,
    }),
  },

  methods: {
    ...mapActions(['updateVisible', 'updateType']),

    handleExpand() {
      this.updateVisible(true);
      this.updateType(this.type);
    },

    async queryDirectActiveAndNew() {
      try {
        const res = await req.send(req.Apis.sales.report.directActiveAndNew, {
          department_id: this.sale[0],
          sales_id: this.sale[1],
          sum: this.sum,
          type: this.type,
        });
        if (res.code === 200) {
          return res.data;
        }
      } catch (err) {
        this.$message.error(err.message);
      }
    },
  },
};
